import { isRejectedWithValue } from '@reduxjs/toolkit'
import { Middleware } from '@reduxjs/toolkit'
import { setPage } from './root'
import { setDialog } from './dialog'
import { RootState } from './store'
import { appApi } from './appApiQueries'
import { isObject } from '../helpers'

// (next) and (action) types are `unknown` intentionally: https://redux-toolkit.js.org/usage/migrating-rtk-2#middleware-type-changed---middleware-action-and-next-are-typed-as-unknown
// and require specific type guards
export const rtkQueryErrorMiddleware: Middleware<object, RootState> =
  (store) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      // if getting the initial subscriptions failed, swallow the error silently
      if (appApi.endpoints.getSubscriptions.matchRejected(action)) {
        return next(action)
      }

      const { message, status } = obtainErrorInfo(action)
      // eslint-disable-next-line no-console
      console.log('🚀 ~ message:', message)

      // we can place more specific error responses here in the future
      if (
        isObject(action?.meta?.arg) &&
        'endpointName' in action.meta.arg &&
        action?.meta?.arg.endpointName === 'unfurlFile' &&
        status === 403 &&
        message === 'No file permissions'
      ) {
        store.dispatch(setDialog({ type: 'noAccess' }))
        return next(action)
      }
      // certain endpoints do not trigger error page (non-critical functionality)
      if (
        isObject(action?.meta?.arg) &&
        'endpointName' in action.meta.arg &&
        (action?.meta?.arg.endpointName === 'getUserAvatar' ||
          action?.meta?.arg.endpointName === 'unsubscribe' ||
          action?.meta?.arg.endpointName === 'subscribe' ||
          action?.meta?.arg.endpointName === 'getSubscriptions' ||
          action?.meta?.arg.endpointName === 'trackMetric') // metrics are optional telemetry
      ) {
        return next(action)
      }
      store.dispatch(setPage('error'))
    }

    return next(action)
  }

export const obtainErrorInfo = (e: unknown) => {
  let message = 'unknown error'
  let status = 500
  let error: unknown
  if (isObject(e)) {
    if (isObject(e.payload)) {
      error = e.payload
    } else if (isObject(e.error)) {
      error = e.error
    } else if (isObject(e.data)) {
      error = e.data
    }
  } else if (typeof e === 'string') {
    message = e
  }

  if (isObject(error)) {
    if ('data' in error && isObject(error.data) && 'message' in error.data) {
      message = (error.data as { message: string }).message
    } else if ('message' in error) {
      message = error.message as string
    }

    if ('status' in error) {
      status = error.status as number
    }
  }

  return { message, status }
}
